module.exports = __webpack_public_path__ + "c548ec19d4c05a5e2e712c6081b73687.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-27.png
// module id = 2979
// module chunks = 0